import { useEffect, useState } from 'react';
import { ApiError } from '../../lib/api';
import { listRoles, type RoleWithPermissions } from './roles.api';

export type RolesCatalogueState = { status: 'loading' } | { status: 'loaded'; roles: RoleWithPermissions[] } | { status: 'forbidden' } | { status: 'error' };

/** Nav-hiding is UX only — a user who reaches this route without `configuration.manage` still gets a real 403 from the server. */
export function useRolesCatalogue(): RolesCatalogueState {
  const [state, setState] = useState<RolesCatalogueState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    listRoles()
      .then((roles) => {
        if (!cancelled) setState({ status: 'loaded', roles });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({ status: err instanceof ApiError && err.status === 403 ? 'forbidden' : 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
